// types

export const CbStatus = {
  NOT_ATTEMPTED: 'NOT_ATTEMPTED',
  SKIPPED: 'SKIPPED',
  ANSWERED: 'ANSWERED',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
};
